// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"style_cardTitle__18N8g"};